import React from 'react';
import resume from '../data/resume';

const Experience = () => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const jobStyle = {
    marginBottom: '15px',
    padding: '10px',
    border: '1px solid #00FF00',
    backgroundColor: '#001100',
    marginLeft: 'clamp(12px, 4vw, 30px)'
  };

  const jobTitleStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '0 0 5px 0',
    letterSpacing: '1px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const companyStyle = {
    fontSize: '14px',
    margin: '0 0 5px 0',
    opacity: 0.9,
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const dateStyle = {
    fontSize: '12px',
    margin: '0 0 8px 0',
    opacity: 0.7,
    fontStyle: 'italic',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const descriptionStyle = {
    fontSize: '13px',
    margin: '0',
    lineHeight: '1.4',
    opacity: 0.8,
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const experiences = resume.experience;

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ cat experience.log</div>
      <h2 style={headingStyle}>[ EXPERIENCE ]</h2>
      {experiences.map((job, index) => (
        <div key={index} style={jobStyle}>
          <h3 style={jobTitleStyle}>┌─ {job.role}</h3>
          <p style={companyStyle}>│ Company: {job.company}</p>
          <p style={dateStyle}>│ Period: {job.dates}</p>
          <p style={descriptionStyle}>└─ {job.points.join(' ')}</p>
        </div>
      ))}
    </section>
  );
};

export default Experience;
